export default {
    "language": "zh_cn",
    "common.user.name": "用户名",
    "common.password": "密码",
    "common.check.all": "全选",
    "common.placeholder": "请输入{0}",
    "common.select.placeholder": "请选择{0}",
    "common.person":"人员{0}",
    "name":"姓名",
    "code":"编号",
    "department":"部门",
    "phone":"电话",
    "paperNumber":"身份证号",
    "leaveTime":"离场时间",
    "apply.reason": "申请原因",
    "pigFarm": "猪场",
    "pigFarm.name":"猪场名称",
    "off.duty":"休班离场",
    "off.duty.return":"休班返场",
    "visitor.approval":"访客审批",

    "login.welcome":"你好，欢迎登录",
    //校验提示
    'validation.regExp.isdLoginName': '仅允许输入字母、数字与_.@字符',
    'validation.regExp.isdPsw': '密码必须包含字母和数字，且在6~20位之间',
    'isd.loginName': '登录名',
    'isd.psw': '登录密码',
    'emailError': '邮箱不合法',
    'maxLen25': '最大长度为25',
    'pleaseInputIp': '请输入ip地址',
    'mustInput': '{0}不能为空',
    'validation.regExpPhone': '请输入合法的手机号',
    'validation.regExpTell': '请输入合法的座机号',
    'validation.regExpFtp': '请输入合法的ftp地址',
    'regExpCarNum': '请输入合法的车牌号',
    'regExpCarNum2': '小于等于十位，只允许输入汉字、大写英文、数字和.',
    'validation.regExpMac': '请输入合法的mac地址',
    'validation.regExp.numAndNum': 'N+M，N的范围为1-16，M的范围为1-4，例如2+1',
    'validation.regExp.email.user': '只允许输入数字、大小写字母、中文、空格与指定特殊字符@#-_,.()（）,且不能以特殊字符与空格开头',
    'validation.regExp.numWord': '仅允许字母、数字',
    'validation.gpsX': '经度仅允许-180.0～+180.0，必须输入1到12位小数',
    'validation.gpsY': '纬度仅允许-90.0～+90.0，必须输入1到12位小数',
    'validation.port': '请输入1~65535的端口号',
    'validation.deviceName': '仅允许输入文字、字母、数字与-_()字符',
    'validation.intercomDevIndex': '请按示例填写编号',
    'validation.secConDev': '确认机分机号范围为200-220',
    'validation.int10': '请输入10位数字',
    'validation.channel.id': '通道ID必须为1-16之间的正整数',
    'linkage.window.rename.error': '不允许输入特殊字符<>',


    'validation.maxlength': '{0}长度不能超过{1}个字符。',
    'validation.minlength': '{0}长度至少为{1}个字符。',
    'validation.max': '{0}不能大于{1}。',
    'validation.min': '{0}不能小于{1}。',
    'validation.required': '请输入{0}。',
    'validation.required.SELECT': '请选择{0}。',
    'validation.number': '{0}必须为数字。',
    'validation.regExp': '{0}不合法。',
    'validation.regExp.name': '仅允许中文、字母、数字、下划线',
    'validation.regExp.positiveInt': '必须为正整数。',
    'validation.regExp.commonCharacter': '仅允许<b>文字字母数字 -_.;#（）[] 半角加号</b>和<b>全角加号</b>以及<b>字符中间有空格</b>。',
    'validation.regExp.nationCharacter': '仅允许<b>文字字母数字</b>。',
    'validation.regExp.hikdomain': '仅允许<b>文字字母数字-_.;#(),\/\\（）[]</b><br/><b>半角加号</b>和<b>全角加号</b>以及允许字符中间有空格',
    'validation.regExp.memoCharacterEnter': '仅允许<b>文字字母数字-_.;,:#（）[]、半角加号、全角加号、空格、回车换行</b>',

    'validation.regExp.searchChar': '不允许同时输入特殊字符<b>/\:*?&quot;<>|（）&</b><br/>、<b></b>。',
    'validation.regExp.userLoginName': '仅允许<b>文字字母数字 _.@</b>',
    'validation.sn': '仅允许<b>字母数字_</b>字符',
    'validation.regExp.codeCharacter': '仅允许数字、字母、下划线和短横线。',
    'validation.regExp.fieldPass': '仅允许<b>-_.;()（）</b>或字母数字。',
    'validation.regExp.codeCharacterOrEmail': '仅允许数字、字母、下划线和短横线或邮箱账号',
    'validation.regExp.pureNum': '必须为非负整数。',
    'validation.other.noLargerThan': '{0}不能大于{1}。',
    'validation.regExp.pass': '仅允许<b>字母数字。',
    'validation.regExp.backupPass': '密码必须包含且仅包含数字字母。',
    'validation.regExp.fewCharacter': '仅允许<b>文字、字母、数字</b>和<b>字符中间空格</b>。',
    'validation.regExp.idCard': '仅允许<b>字母</b>和<b>数字</b>。',
    'validation.node.channel.empty': '该节点下无资源。',
    'validation.regExp.different': '两次输入的密码不一致',
    'validation.regExp.decmal3': '浮点数，小数部分最多2位',
    //密码校验
    'password.info.length': '密码为8-32个字符',
    'password.info.include': '密码不能包含<b>\'、\"、;、:、&</b>等字符',
    'password.info.simple': '密码必须包含<b>英文字母、数字、特殊字符</b>中的至少两种',

    // 生物安全 2020-05-20
    // 菜单权限
	"evo-biosafe": "生物安全子系统",
	"install.evo-biosafe": "完成养猪场人员、车辆、消毒等生物安全管理业务应用",
	"module.evo-biosafe": "生物安全业务服务",
	"module.evo-biosafe.desc": "生物安全业务服务",
	"appmodule_custom_biosafe":"生物安全",
	"EVOBIOSAFE_001":"生物安全子系统",
	"EVOBIOSAFE_001001":"预约审批",
	"EVOBIOSAFE_001001001":"审批记录",
	"EVOBIOSAFE_001001002":"访客来访记录",
    "EVOBIOSAFE_001001003":"刷卡记录",
    "EVOBIOSAFE_001002":"人员采样管理",
    "EVOBIOSAFE_001003":"环境管理",
    "EVOBIOSAFE_001003001":"环境消毒",
    "EVOBIOSAFE_001003002":"环境采样",
    "EVOBIOSAFE_001003003":"巡查记录",
    "EVOBIOSAFE_001003004":"设备巡检",
    "EVOBIOSAFE_001003005":"周边调查",
    "EVOBIOSAFE_001004":"车辆管理",
    "EVOBIOSAFE_001004001":"车辆状态信息",
    "EVOBIOSAFE_001004002":"车载设备检测",
    "EVOBIOSAFE_001004003":"车辆行驶记录",
    "EVOBIOSAFE_001004004":"人员中转车洗消记录",
    "EVOBIOSAFE_001004005":"人员中转车周2次洗消采样",
    "EVOBIOSAFE_001004006":"车辆洗检查记录",
    "EVOBIOSAFE_001004007":"车辆洗消毒检查记录",
    "EVOBIOSAFE_001004008":"靠场车辆检查消毒",
    "EVOBIOSAFE_001004009":"场外粪肥中转车登记",
    "EVOBIOSAFE_001004010":"车打料采样登记",
    "EVOBIOSAFE_001005":"物资管理",
    "EVOBIOSAFE_001005001":"中转物资登记",
    "EVOBIOSAFE_001005002":"中转物资采样",
    "EVOBIOSAFE_001005003":"食材登记",
    "EVOBIOSAFE_001005004":"食材采样",
    "EVOBIOSAFE_001005005":"非中转物资厂家装货登记",
    "EVOBIOSAFE_001005006":"非中转物资登记",
    "EVOBIOSAFE_001006":"字典维护",
    "EVOBIOSAFE_001007":"可视大屏",
    "EVOBIOSAFE_001008":"信息中心",
    "EVOBIOSAFE_001008001":"消息公告",
    "EVOBIOSAFE_001008002":"短信模板",
    "EVOBIOSAFE_001008003":"SOP业务报警信息",
    "EVOBIOSAFE_001009":"我的任务",
    "EVOBIOSAFE_001009001":"规则配置",
    "EVOBIOSAFE_001009002":"创建任务",
    "EVOBIOSAFE_001009003":"待办任务",
    "EVOBIOSAFE_001009004":"历史任务",


    "error401":"权限受限",
    "error301":"永久重定向",
    "error403":"访问禁止",
    "error404":"未找到资源",
    "error500":"服务器内部错误",
    "error502":"网关错误",
    "error504":"网关超时",
    "error22020039":"有模拟室内机正绑定此设备",
    "error22020040": "小区-楼栋-单元组织名称过长 致设备及通道名称大于 50 个字，请调整各节点组织名称为合理长度",
    "error28170022": "部门或下级部门包含卡片",
    "error28170023": "部门或下级部门包含车辆",
    "error42100001": "资源打包请求达到上限，请稍后再试…",
    "error42100005": "正在打包中，请稍后…",
    "error28110062": "子系统已经被卸载，请联系管理员",
    "error42100006": "地址不合法",
    "error28130036": "导入进度数量不合法",
    "error28130037": "该导入任务已结束",
    "error28130038": "导入进度不合法",
    "error28130039": "设备导入导出信息不合法",
    "error28130040": "子系统上报的模板信息不能为空",
    "error28130041": "没有设备信息需要导出",
    "error28130042": "导出的设备信息缺少设备大类",
    "error28130043": "导出的设备信息缺少设备编码",
    "error28130044": "导出进度不合法",
    "error28130045": "该导出任务已结束",
    "error28130049": "当前有其他用户正在进行设备信息导入，为了避免数据处理异常，请稍后重试 ",
    "error28130050": "当前有其他用户正在进行设备信息导出，为了避免数据处理异常，请稍后重试 ",
    "error28999972": "导入文件为空",
    "error28999974": "文件解析失败",
    "error28999975": "文件数据不能为空",
    "error28999983": "上传文件不合法，可能已经损坏！",
    "error28999984": "未输入密码或密码错误",
    'error00000000': '网络异常',
    "error22020027": "设备编码为空 ",
    "error28100034": "组织正在删除",
    "error28100035": "组织正在添加下级组织",
    "error28100036": "组织正在更新",
    "error28100037": "forbidBindUser 参数校验",
    "error28100038": "operateLock 参数校验",
    "error28100039": "operateLock 不能为空",
    "error28100040": "forbidBindUser 不能为空",
    "error22020029": "可视对讲子系统删除设备失败 ",
    "error22020030": "基础资源服务删除失败 ",
    "error22020031": "设备正在使用门禁高级功能,无法删除 ",
    "error22020032": "删除门口机或者围墙机时，有权限分组或卡片正引用此门口机或者围墙机 ",
    "error22020033": "删除室内机时，有权限分组或卡片正引用此室内机 ",
    "error22020034": "无法删除，监视权限已绑定该室内机 ",
    "error22000001": "参数不能为空",
    "error22000002": "参数格式有误",
    "error22020001": "组织添加失败",
    "error22020002": "组织修改失败",
    "error22020003": "组织删除失败",
    "error22020004": "组织已经存在",
    "error22020005": "组织类型错误",
    "error22020006": "组织不存在",
    "error22020007": "组织格式错误",
    "error22020008": "组织ID不能为空",
    "error22020009": "组织不允许删除",
    "error22020010": "组织不能为空",
    "error22010001": "设备添加失败",
    "error22010002": "设备修改失败",
    "error22010003": "设备删除失败",
    "error22010004": "设备类型不能为空",
    "error22010005": "设备类型错误",
    "error22010006": "设备呼叫号码错误",
    "error22010007": "设备呼叫号码不能为空",
    "error22010008": "无法在组织下添加该类设备",
    "error22010009": "设备名称不能为空",
    "error22010010": "设备名称不能超过50个字符！",
    "error22010011": "设备厂商不能为空",
    "error22010012": "设备账号不能为空",
    "error22010013": "设备密码不能为空",
    "error22010014": "设备添加方式不能为空",
    "error22010015": "设备地址不为空",
    "error22020037": "session 信息失效",
    "error22020038": "设备导入失败",
    "error22100205": "已达到最大值",
    "error22100206": "组织不允许删除",
    "error22100207": "父节点不存在",
    "error22100208": "组织已存在",
    "error22020035": "设备不存在 ",
    "error22020036": "请求参数为空 ",
    "error29020027": "设备编码为空 ",
    "error29020029": "停车子系统删除设备失败 ",
    "error29020031": "设备正在使用门禁高级功能,无法删除 ",
    "error29020030": "基础资源服务删除失败 ",
    "error29020035": "设备不存在 ",
    "error29020036": "请求参数为空 ",
    "error33020027": "设备编码为空 ",
    "error33020029": "动环子系统删除设备失败 ",
    "error33020030": "基础资源服务删除失败 ",
    "error33020031": "设备正在使用门禁高级功能,无法删除 ",
    "error33020035": "设备不存在 ",
    "error33020036": "请求参数为空 ",
    "error43020027": "设备编码为空 ",
    "error43020029": "报警子系统删除设备失败 ",
    "error43020030": "基础资源服务删除失败 ",
    "error43020031": "设备正在使用门禁高级功能,无法删除 ",
    "error43020035": "设备不存在 ",
    "error43020036": "请求参数为空 ",
    "error44020027": "设备编码为空 ",
    "error44020028": "可视对讲删除设备失败 ",
    "error44020029": "门禁子系统删除设备失败 ",
    "error44020030": "基础资源服务删除失败 ",
    "error44020031": "设备正在使用门禁高级功能,无法删除 ",
    "error44020035": "设备不存在 ",
    "error44020036": "请求参数为空 ",
    "error47020027": "设备编码为空 ",
    "error47020029": "访客子系统删除设备失败 ",
    "error47020030": "基础资源服务删除失败 ",
    "error47020031": "设备正在使用门禁高级功能,无法删除 ",
    "error47020035": "设备不存在 ",
    "error47020036": "请求参数为空 ",
    "error48020027": "设备编码为空 ",
    "error48020029": "梯控子系统删除设备失败 ",
    "error48020030": "基础资源服务删除失败 ",
    "error48020031": "设备正在使用门禁高级功能,无法删除 ",
    "error48020035": "设备不存在 ",
    "error48020036": "请求参数为空 ",
    "error49020027": "设备编码为空 ",
    "error49020029": "消费子系统删除设备失败 ",
    "error49020030": "基础资源服务删除失败 ",
    "error49020031": "设备正在使用门禁高级功能,无法删除 ",
    "error49020035": "设备不存在 ",
    "error49020036": " 请求参数为空 ",
    'error020035': '设备不存在',
    'error020036': '请求参数为空',
    'error20010037': '该通道已下发人脸库',
    'error20010033': '设备跟电视墙关联',
    'error20010034': '服务异常，该设备不能删除',
    'error20010035': '设备与报警预案关联',
    'error20010036': '数据库中不存在该设备',
    'error48000001': '数据库操作异常',
    'error48000002': '空指针异常',
    'error48000003': '读写异常',
    'error48000004': '数学运算异常',
    'error48000005': '数组下标越界',
    'error48000006': '方法参数错误',
    'error48000007': '类转换异常',
    'error48000008': '违背安全原则异常',
    'error48000009': 'XmlUtil读取流失败',
    'error48000010': 'token为空',
    'error48000011': '全量同步用户失败',
    'error48000012': '同步新增用户失败',
    'error48000013': '同步修改用户失败',
    'error48000014': '同步删除用户失败',
    'error48000015': '全量同步角色失败',
    'error48000016': '同步新增角色失败',
    'error48000017': '同步修改角色失败',
    'error48000018': '同步删除角色失败',
    'error48000019': '同步新增组织失败',
    'error48000020': '数据库操作异常',
    'error48000021': '同步删除部门失败',
    'error48000022': '同步修改部门失败',
    'error48000023': '全量同步人员失败',
    'error48000024': '同步新增人员失败',
    'error48000025': '同步删除人员失败',
    'error48000026': '同步修改人员失败',
    'error48000027': '全量同步卡片失败',
    'error48000028': '同步新增卡片失败',
    'error48000029': '同步删除卡片失败',
    'error48000030': '同步修改卡片失败',
    'error48000031': '订阅同步刷卡记录失败',
    'error48000032': '卡片不是激活卡，不能授权',
    'error48000033': '组织名称已存在',
    'error48000034': '组织名称为空',
    'error48000035': '组织编码为空',
    'error48000036': '组织编码已存在',
    'error48000037': '父组织不存在',
    'error48000038': '集成系统添加设备失败',
    'error48000039': '集成系统删除设备失败',
    'error48000040': '集成系统更新设备失败',
    'error48000041': '子系统token为空',
    'error48000042': '设备编码获取失败',
    'error48000043': '树类型编码参数错误',
    'error48000044': '树类型编码参数为空',
    'error48000045': '组织节点ID参数错误',
    'error48000046': '部门名称已存在',
    'error48000047': '部门名称已存在',
    'error48000048': '卡号不存在',
    'error48000049': '卡片类型错误',
    'error48000050': '卡号为空',
    'error48000051': '部门下有人员，无法删除部门',
    'error48000052': '部门下子部门，无法删除部门',
    'error48000053': '存在相同的人员ID',
    'error48000054': '查询不到人员',
    'error48000055': '部门父节点不存在',
    'error48000056': '加载秘钥失败',
    'error48000057': '未注册门禁服务',
    'error48010002': '设备厂商为空',
    'error48010003': '设备型号为空',
    'error48010004': '设备登录类型为空',
    'error48010005': '设备类型为空',
    'error48010006': '设备种类为空',
    'error48010007': '设备登录用户为空',
    'error48010008': '设备登录密码为空',
    'error48010009': '设备IP为空',
    'error48010010': '设备端口为空',
    'error48010011': '设备名称为空',
    'error48010012': '设备名称已存在',
    'error48010013': 'MCD服务为空',
    'error48010014': 'MCD服务不在线',
    'error48010015': '门禁设备不在线',
    'error48010016': 'ACDG服务为空',
    'error48010017': 'ACDG服务不在线',
    'error48010018': '设备IP已存在',
    'error48010019': '设备IP和端口已存在',
    'error48010020': '门组名称为空',
    'error48010021': '门组包含的通道数量不能超过50',
    'error48010022': '修改门组包含的通道数量不能超过50',
    'error48010023': '门组名称已存在',
    'error48010024': '卡片权限允许添加的通道与门组之和不能超过100',
    'error48010025': '获取按人授权列表失败',
    'error48010030': '修改卡片权限失败',
    'error48010031': '删除卡片权限失败',
    'error48010032': '查询权限失败',
    'error48010033': '部门授权失败',
    'error48010034': '删除部门授权失败',
    'error48010035': '修改部门授权失败',
    'error48010036': '添加设备失败',
    'error48010037': '修改设备失败',
    'error48010038': '删除设备失败',
    'error48010039': '设备代理端口获取失败',
    'error48010040': '设备编号获取失败',
    'error48010041': '设备新增至基础资源失败',
    'error48010042': '设备信息修改同步至基础资源失败',
    'error48010043': '设备数量超限',
    'error48010044': '设备注册id重复',
    'error48020001': '已存在相同卡号对应的梯控授权信息',
    'error48020002': '不存在卡号为{0}的授权信息',
    'error48030001': '查询梯控计划失败',
    'error48030002': '获取高平峰配置失败',
    'error48030007': '删除高平峰配置失败',
    'error48030008': '修改高平峰配置失败',
    'error48030009': '新增高平峰配置失败',
    'error48030003': '新增梯控计划失败',
    'error48030004': '修改梯控计划失败',
    'error48030005': '删除梯控计划失败',
    'error48030006': '获取假日计划失败失败',
    'error48040001': '查询刷卡记录失败',
    'error003002': '设备名称已存在',
    'error020027': '类型转换错误',
    'error020028': '违背安全原则异常',
    'error020029': 'SQL相关错误',
    'error020030': '未知的运行时错误',
    'error020031': '参数校验不通过',
    'error000001': '最大充值金额为:{0}！',
    'error000002': '账户最大金额为:{0}！',
    'error000003': '已存在名称为:{0}的消费规则！',
    'error000004': '营业单位下有消费设备，不能删除！',
    'error000005': '已存在同名称:{0}的营业单位！',
    'error000006': '设备编号:{0}不存在',
    'error000008': '不存在编码为:{0}的营业单位!',
    'error000009': '已存在名称为:{0}的营业时段规则!',
    'error000010': '该营业时段规则有关联的设备，不能删除!',
    'error000011': '该人员:{0}未绑定卡片!',
    'error000012': '卡:{0}为空白卡！',
    'error000013': '卡:{0}为注销卡！',
    'error000014': '此人员绑定的卡片没有消费权限,不能充值!',
    'error000015': '部门父节点不存在',
    'error000016': '卡片不存在',
    'error000017': '所选卡片全是未授权，无法删除',
    'error000018': '已存在同名的身份!',
    'error000019': '找不到要编辑的人员信息!',
    'error000020': '部门下有人员，不能删除！',
    'error000021': '部门下存在子部门，无法删除！',
    'error000022': '已存在同名称的部门',
    'error000023': '厂家列表为空！',
    'error000024': '已存在相同ID的人员！',
    'error000025': '该卡片未绑定人员，不允许充值！',
    'error000026': '该身份不允许系统充值！',
    'error000027': '最大充值金额为:{0}，当前充值金额为:{1}，无法充值！',
    'error000028': '卡号：{0}的账户最大金额为:{1}，充值之后金额为:{2}，无法充值！该卡号及以下数据将不做导入，请修改后重试！',
    'error28210100': '必填参数不能为空',
    'error28210101': '添加类型参数非法',
    'error28210102': '级联方式参数非法',
    'error28210103': '域信息已存在',
    'error28210104': '插入数据库错误',
    'error28210105': '注册与发现地址为空',
    'error28210106': '域关联关系不存在',
    'error28210107': '域信息不存在',
    'error28210108': '域非正常状态，无法关闭',
    'error28210109': '开启同步数据失败',
    'error28210110': '更新参数非法',
    'error28210111': '更新组织失败',
    'error28210112': '没有可用的域ID',
    'error28210113': '获取MAS公钥为空',
    'error28210114': '密码解密失败',
    'error99020022': '数据库操作异常',
    'error23999999': '设备IP或端口已经被占用',
    'error506': '通道数量超过加密狗限制',
    'error27001010': '记住密码已过期',
    'error99020026': '数组下标越界错误',
    'error99020021': '参数不合法',
    'error27001000': '自定义异常',
    'error27001001': '请求参数格式不正确',
    'error27002002': 'redis异常',
    'error27002003': 'token不能为空',
    'error27001004': '加密方式有误',
    'error27003005': '数据提供方异常',
    'error27003006': '订阅基础资源服务失败',
    'error27003007': '无效的access_token',
    'error27011001': '无效的客户端授权',
    'error27012002': '注销失败',
    'error27013003': 'Oauth2框架返回的异常信息',
    'error27013004': '用户名不能为空',
    'error27011005': '用户名或密码错误',
    'error27001008': '记住密码已过期',
    'error28100000': '同级下存在同名组织',
    'error28100001': '单层组织子节点超过最大数（999）',
    'error28100002': '上级组织节点不存在',
    'error28100003': '组织唯一标识码已存在',
    'error28100004': '生成组织编码失败',
    'error28100005': '组织节点不存在',
    'error28100006': '根节点不允许删除',
    'error28100007': '要删除的组织节点存在子节点，不能删除',
    'error28100008': '组织或下级组织绑定了设备，不能被删除',
    'error28100009': '组织下已绑定角色，不能删除',
    'error28100010': '组织下已绑定用户，不能删除',
    'error28100011': '组织编码不能为空',
    'error28100012': '组织名称不能为空',
    'error28100013': '组织名称字符非法或者长度超过了25',
    'error28100014': '组织类型长度不能超过10',
    'error28100015': '上级组织编码不能为空',
    'error28100016': '组织唯一标识码长度不能超过50',
    'error28100017': '要删除的组织编码不存在',
    'error28100018': '组织层级不能超过10级',
    'error28100020': 'previousSort与nextSort参数至少有一个值不为空',
    'error28100021': '用户没有组织权限',
    'error28100022': '组织权限状态属性(checkStat)不能为空',
    'error28100023': '地区编码不存在',
    'error28100024': '组织类型不能为空',
    'error28100025': '组织新增操作权限被锁定',
    'error28100026': '组织更新操作权限被锁定',
    'error28100027': '组织删除操作权限被锁定',
    'error28100028': '组织新增设备操作权限被锁定',
    'error28100029': '组织操作权限锁已存在',
    'error28100030': '组织禁止绑定用户被其他子系统设置',
    'error28100031': '组织禁止绑定用户',
    'error28100032': '组织上下级类型校验非法',
    'error28100033': '下级级联组织无法添加设备',
    'error28110000': '已存在用户名为{0}的用户，请重新输入用户名',
    'error28110001': '证件号码已经存在',
    'error28110002': '手机号码已经存在',
    'error28110003': '账号不存在，请重新输入',
    'error28110004': '登录用户名密码不能为空',
    'error28110005': '用户名或密码错误',
    'error28110006': '用户被锁定',
    'error28110007': '用户被冻结，无法登录系统',
    'error28110008': '登录日期不在有效期内',
    'error28110009': '用户名或密码错误，还可重试{0}次',
    'error28110068': '平台授权时间已经到期，请到运维中心-系统管理-授权管理中更新授权信息',
    'error28110010': '密码错误次数已达上限，锁定{0}分钟',
    'error28110011': '平台默认用户不能删除',
    'error28110012': '用户重置密码token不能为空',
    'error28110013': '用户重置密码的token不正确',
    'error28110014': '密码必须为8-16个字符',
    'error28110015': '用户权限不够',
    'error28110016': '用户更新失败',
    'error28110017': '用户名不能为空',
    'error28110018': '插入用户失败',
    'error28110019': '插入用户扩展信息失败',
    'error28110020': '用户角色关联关系插入失败',
    'error28110021': '用户密码非初始化密码，不能修改',
    'error28110022': '访问记录菜单编码不能为空',
    'error28110023': '用户不存在密保问题',
    'error28110024': '用户密码不正确',
    'error28110025': '当前操作用户不存在',
    'error28110026': '密码过于简单，请使用数字、大小写字母、特殊符号。',
    'error28110027': '该人员已绑定用户，请重新绑定',
    'error28110028': '用户角色不能为空',
    'error28110029': '密保问题数据插入错误',
    'error28110030': '密保问题和用户关系数据插入错误',
    'error28110031': '您回答错了，再仔细想想',
    'error28110032': '所属组织不能为空',
    'error28110033': '登录名称非法，必须是25位以内的非特殊字符',
    'error28110034': '用户id不能为空',
    'error28110035': '用户复用标志位不能为空',
    'error28110036': '用户的personId不能为空',
    'error28110038': '菜单编码不能为空',
    'error28110039': '菜单排序信息不能为空',
    'error28110040': '访问菜单编码不能为空',
    'error28110041': '访问缩略图不能为空',
    'error28110042': '客户端类型为不能空',
    'error28110043': '客户端MAC地址为不能空',
    'error28110044': '公钥不能为空',
    'error28110045': '密保问题id不能为空',
    'error28110046': '密保问题答案不能为空',
    'error28110047': '密保问题列表不能为空',
    'error28110048': '平台默认用户不能修改',
    'error28110049': '删除用户不能为空',
    'error28110050': '正确的密保问题数量不对',
    'error28110051': '密保问题列表不能为空',
    'error28110052': '与平台密保问题不符',
    'error28110053': '用户没有复用，不能重复登录',
    'error28110054': '非system用户不能重置system的密码',
    'error28110055': '用户是否复用标志位值非法',
    'error28110056': '用户修改的密码不能和原密码相同',
    'error28120000': '角色已存在',
    'error28120001': '角色不存在',
    'error28120002': '默认角色不允许删除',
    'error28120003': '默认角色不允许编辑',
    'error28120004': '要删除的角色已经绑定用户，不能删除',
    'error28120005': '角色ID不能为空',
    'error28120006': '角色名称不能为空',
    'error28120007': '角色名称非法，必须是0-25位的合法字符',
    'error28120008': '角色所属组织信息不能为空',
    'error28120009': '角色等级不能为空',
    'error28120010': '角色等级非法',
    'error28120011': '备注信息长度不能超过250',
    'error28130000': '转码器已存在，平台只能添加一台转码器设备',
    'error28130001': '客户端IP已被占用',
    'error28130002': 'Ip设备的序列号重复',
    'error28130003': '外网IP端口重复',
    'error28130004': '设备不存在',
    'error28130005': '设备编码已经存在',
    'error28130006': '设备唯一标识码已经存在',
    'error28130007': '设备IP或端口已经存在',
    'error28130008': '主动注册代理端口已存在',
    'error28130009': '通道唯一标识码已存在',
    'error28130010': '设备端口非法',
    'error28130011': '设备主动注册代理端口非法',
    'error28130012': '设备所属组织不存在',
    'error28130013': '设备编码不能为空',
    'error28130014': '设备类别不能为空',
    'error28130015': '设备类型不能为空',
    'error28130016': '设备名称不能为空',
    'error28130017': '设备编码越界',
    'error28130018': '设备编码单次最多生成500个',
    'error28130019': '服务器代理端口不足',
    'error28130020': '服务器代理端口单次最多生成500个',
    'error28130021': '服务器编码非法,只能是1-32位数字、字母、-、_、.、$、:、#',
    'error28130022': '生成设备编码数必须是正整数',
    'error28130023': '设备厂商不能为空',
    'error28130025': '主动注册设备注册ID不能为空',
    'error28130026': 'IP地址注册设备IP或端口不能为空',
    'error28130027': '设备编码不存在',
    'error28130028': '通道编码不存在',
    'error28130029': '设备通道所属组织不能为空',
    'error28130030': '移动的设备通道不能为空',
    'error28130031': '设备通道名称不能为空',
    'error28999976': '加密密码不能为空',
    'error28999977': '秘钥key不能为空',
    'error28999978': '秘钥key不存在',
    'error28999979': '导入文件已加密',
    'error28999980': '请求接口响应为空',
    'error28999981': 'version.text文件内容格式有误',
    'error28999982': '上传文件不合法,请上传zip压缩文件',
    'error28999983': '上传文件不合法，可能已经损坏！',
    'error28999984': '未输入密码或密码错误',
    'error28999985': 'pageNumber大小不能小于1 ',
    'error28999986': 'pageSize大小不能小于1',
    'error28999988': '接口未实现',
    'error28999989': '方法未实现',
    'error28140000': '该卡片已经存在',
    'error28140001': '卡片不存在',
    'error28140002': '卡号不能为空',
    'error28140003': '卡片信息不能为空',
    'error28140017': "卡片密码校验非法",
    'error28150000': '车牌号已经存在',
    'error28150001': '车辆不存在',
    'error28150002': '车牌号不能为空',
    'error28150003': '车辆信息不能为空',
    'error28150008': '车辆导出失败',
    'error28150009': '车辆导入失败',
    'error28150010': '子系统限制变更',
    'error28150011': '车牌颜色错误',
    'error28150012': '车辆品牌错误',
    'error28150013': '车辆类型错误',
    'error28150014': '车身颜色错误',
    'error28150015': '车牌号（必填）',
    'error28150016': '车牌颜色',
    'error28150017': '车辆类型',
    'error28150018': '车身颜色',
    'error28150019': '车辆品牌',
    'error28150020': '车主编码',
    'error28150021': '部门名称（必填）',
    'error28150022': '车牌号格式错误',
    'error28150023': '该用户可有车辆数超标',
    'error28150024': '车主姓名',
    'error28170020': '部门名称为空',
    'error28160014': '缺少自定义表头配置',
    'error28160015': '缺少请求参数',
    'error28160016': '非法的人员状态',
    'error28160017': '删除失败，该人员已绑定用户',
    'error28160018': '更新人员信息失败',
    'error28160002': '人员信息不存在',
    'error28160000': '人员编码已存在',
    'error28160003': '人员ID不能为空',
    'error28160004': '人员编码不能为空',
    'error28160005': '人员姓名不能为空',
    'error28160006': '证件类型不能为空',
    'error28160007': '证件号码不能为空',
    'error28160009': '人员所属部门不存在',
    'error28160008': '部门ID不能为空',
    'error28160010': '人员名称非法,必须是0-25位的非特殊字符',
    'error28160011': '人员ID不能为空',
    'error28160012': '人员不能为空',
    'error28160013': '电话号码格式错误',
    'error28160019': '非法的图片类型',
    'error28160020': '非法的图片大小',
    'error28160021': '人员信息已存在',
    'error28160022': '证件地址非法',
    'error28160024': '非法证件类型',
    'error28160025': '批量转移所属部门人员包含已删除人员',
    'error28160026': 'copyId不是删除状态人员ID',
    'error28160027': '文件参数不能全为空',
    'error28160028': '人员ID不存在',
    'error28160029': '人员ID不是删除状态',
    'error28160030': 'copyID不是删除状态',
    'error28160032': '未知生物特征类型',
    'error28160033': '证件号非法',
    'error28160035': '手机号已存在',
    'error28160036': '生物特征类型校验非法',
    'error28160037': '人脸头像生物特征校验非法',
    'error28160038': '指纹生物特征校验非法',
    'error28160039': '人员编码非法',
    'error28160040': '人员鉴权',
    'error28160042': '非法国家/地区',
    'error28160043': '非法民族',
    'error28160044': '非法性别',
    'error28160045': '非法生日',
    'error28160046': '人员编码不存在',
    'error28160047': '人员部门不匹配',
    'error28160048': '人员邮箱校验',
    'error28160049': '人员头像图片名称非法',
    'error28160050': '非法的人员身份',
    'error28160051': '人员导入已存在',
    'error28170000': '上级部门不存在',
    'error28170001': '同级部门名称不能重复',
    'error28170002': '部门不存在',
    'error28170003': '要删除的部门下存在下级节点，不能删除',
    'error28170004': '部门ID不能为空',
    'error28170005': '部门上级节点不能为空',
    'error28170006': '部门名称不能为空',
    'error28170007': '根部门不允许删除',
    'error28170008': '部门或下级部门绑定人员不能被删除',
    'error28170009': '用户没有部门权限',
    'error28170010': '部门不能移到本部门或下级部门',
    'error28170011': '单层部门子节点超过最大数(10)',
    'error28170012': '上传文件不是Excel文件',
    'error28170013': '部门名称包含非法字符或长度超过25',
    'error28170014': '用户没有一个部门权限',
    'error28170015': '部门新增操作权限被{0}锁定',
    'error28170016': '部门更新操作权限被{0}锁定',
    'error28170017': '部门删除操作权限被{0}锁定',
    'error28170018': '部门下新增人员操作权限被{0}锁定',
    'error28170019': '部门操作权限锁已存在',
    'error28170021': '部门信息不能为空',
    'error28180000': '子系统名称不能为空',
    'error28180001': '子系统编码不能为空',
    'error28180002': '子系统ip不能为空',
    'error28180003': '子系统端口不能为空',
    'error28180004': '菜单编码不能为空',
    'error28180005': '菜单名称不能为空',
    'error28180006': '菜单所属终端不能为空',
    'error28180007': '菜单所属业务模块不能为空',
    'error28180008': '订阅数据条件信息非法',
    'error28180009': '菜单不存在',
    'error28180010': '终端不存在',
    'error28999987': 'weboss服务异常',
    'error28999990': '客户端终端类型不正确',
    'error28999991': '插件下载路径不存在',
    'error28999992': '用户ID为空',
    'error28999993': '客户端版本信息读取失败',
    'error28999994': '客户端版本信息文件不存在',
    'error28999995': '客户端版本信息为空',
    'error28999996': '排序属性非法',
    'error28999997': '排序方式非法',
    'error28999998': '服务名称不能为空',
    'error28999999': '参数非法,{0}',
    'error28110057': '初始密码不能为空',
    'error28110058': '原密码不能为空',
    'error28110059': '初始密码错误',
    'error28110060': '原密码错误',
    'error28110061': '密保问题回答错误次数已达上限，锁定5分钟',
    'error28160001': '证件号码已存在',
    'error28200001': '资源已绑定',
    'error28200000': '不能绑定自身',
    'error28180016': '菜单所属应用大类名称非法',
    'error41100019': '筛选数据为空',
    'error28180017': '菜单所属应用大类名称重复',
    'error1103': '该用户没有权限',
    'error3099': '级联服务异常',
    'error2016': '设备不存在',
    'error3000': '服务异常',
    'error41012001': '新增模板失败',
    'error40012005': '该模板已绑定预案，不能删除',
    'error41012002': '模板不存在',
    'error41012003': '重复的模板名称',
    'error41012004': '模板类型不能为空',
    'error41001000': '服务端异常',
    'error41001001': '请求参数格式不正确',
    'error41002002': 'redis异常',
    'error27001009': '非法的remember_token',
    'error41021003': '邮箱服务器配置有误',
    'error41022005': '邮件服务器异常',
    'error41022004': '发送邮件失败',
    'error41032004': '发送短信失败',
    'error41031006': '短信中心号码格式错误',
    'error41032005': '短信猫异常',
    'error41042001': '删除联动短信失败',
    'error26000001': '监听队列不能为空',
    'error26000002': '监听类型不能为空',
    'error26000003': '事件大类不能为空',
    'error26000004': '系统类型不能为空',
    'error26000005': '订阅者名称不能为空',
    'error26000006': '订阅者magic信息不能为空',
    'error26000007': '联动动作名称不能为空',
    'error26000008': '联动动作url不能为空',
    'error26010000': '报警类型key不能为空',
    'error26010001': '报警类型不能为空',
    'error26010002': '报警类型归属不能为空',
    'error26010003': '报警类型归属key不能为空',
    'error26010004': '报警类型归属大类不能为空',
    'error26010005': '报警类型归属大类不能为空',
    'error26010006': '报警类型国际化语言不能为空',
    'error26010007': '报警类型名称不能为空',
    'error26010008': '报警类型归属名称不能为空',
    'error26010009': '报警类型归属大类名称不',
    'error26010010': '报警类型更新id不能为空',
    'error26010011': '报警类型更新参数不能为空',
    'error26010012': '报警类型更新状态参数错误',
    'error26010013': '报警类型更新报警等级参数错误',
    'error26010014': '报警类型更新报警风暴参数错误',
    'error26010015': '报警类型更新白名单参数错误',
    'error26020000': '报警预案id不能为空',
    'error26020001': '报警预案时间模板id不能为空',
    'error26020002': '报警预案旧时间模板id不能为空',
    'error26020003': '报警预案不存在',
    'error26020004': '报警预案新老时间模板一致',
    'error26100000': '订阅信息入库失败',
    'error26100001': '订阅事件入库失败',
    'error26100002': '订阅信息不存在',
    'error26100003': '订阅事件不存在',
    'error26100004': '联动动作入库失败',
    'error26030101': '时间模板名称不能为空',
    'error26030102': '时间模板名称超过范围',
    'error26030103': '时间模板名称不能包含非法字符且长度不能超过25',
    'error26030104': '时间模板周参数错误',
    'error26030105': '参数不能为空',
    'error26030106': '时间模板时段数量错误',
    'error26030107': '时间模板时段数量超过上限',
    'error26030108': '时间模板类型错误',
    'error26030109': '时间模板名称重复',
    'error26030110': '时间模板时间开始时间大于结束时间',
    'error26030111': '时间模板时段重叠',
    'error26030112': '不能是默认时间模板转型',
    'error26030113': '等修改的对象不存在',
    'error26030114': '时间模板时段数据不能大于7天',
    'error26030115': '时间模板时段类型非法',
    'error26030116': '非默认模板不能恢复默认',
    'error26030117': '预案更新的时间模板为空',
    'error26999900': '分页排序属性非法',
    'error26999901': '分页排序类型非法',
    'error26020005': '更新报警预案状态值不对',
    'error26020006': '报警预案名称不合法',
    'error26020007': '报警预案类型列表不为空',
    'error26020008': '报警预案状态不为空',
    'error26020009': '报警预案状态值不对',
    'error26020010': '报警预案状态值不对',
    'error26020011': '报警预案报警源以及联动动作的数组不为空',
    'error26020012': '报警预案报警源错误',
    'error26020013': '报警预案联动动作名称错误',
    'error26020014': '报警预案联动动作ID错误',
    'error26020015': '子系统联动动作url错误',
    'error26020016': '报警预案类型归属不为空',
    'error26020017': '报警预案已存在',
    'error26020018': '报警预案预案id不为空',
    'error26020019': '报警预案预案名称已存在',
    'error26040000': '报警日志处理用户不能为空',
    'error26040001': '报警日志处理时间不能为空',
    'error26040002': '报警日志处理状态不能为空',
    'error26040003': '报警日志报警编号不能为空',
    'error26040004': '报警日志处理状态非法',
    'error26999902': '当前页非法',
    'error26999903': '分页每页数量非法',
    'error26020021': '报警预案添加失败',
    'error26020023': '报警预案删除失败',
    'error26020022': '报警预案更新失败',
    'error26010017': '报警类型更新id列表不正确',
    'error26020024': '报警预案权限不正确',
    'error26020025': '报警预案的报警类型不存在',
    'error26020026': '报警预案的报警类型和归属关系不正确',
    'error26100005': '订阅协议不正确',
    'error26040005': '用户权限不足',
    'error26040006': '报警日志处理内容过长',
    'error26040007': '报警日志不存在',
    'error26040008': '报警日志导出参数错误',
    'error26040009': '报警日志导出数量过长',
    'error26040010': '报警日志导出数量为空',
    'error26040011': '报警日志导出服务不存在',
    'error26040012': '报警日志导出公钥创建失败',
    'error26040013': '报警日志导出公钥不存在',
    'error26040014': '报警日志导出公钥过期',
    'error26040015': '报警日志导出密码解密失败',
    'error26040016': '报警日志导出服务正在运行中，请稍后再试',
    'error26020027': '设备不存在',
    'error26000009': '公钥不能为空',
    'error26020028': '报警源数量不能超过100',
    'error26010018': '报警类型归属不存在',
    'error26010019': '报警等级不能为空',
    'error26010020': '报警风暴不能为空',
    'error26010021': '报警类型白名单不能为空',
    'error26010022': '报警类型是否禁用不能为空',
    'error26010023': '报警等级错误',
    'error26010024': '报警风暴错误',
    'error26010025': '报警类型白名单错误',
    'error26010026': '报警类型禁用错误',
    'error26010027': '报警类型名称非法',
    'error26010028': '自定义报警类型更新时名称和语言必须同时存在',
    'error26010029': '报警类型不存在',
    'error26010030': '非自定义报警类型不能修改名称',
    'error26010031': '非自定义报警类型不能删除',
    'error26010032': '自定义报警类型应用于报警预案，请先修改预案',
    'error26010033': '自定义报警类型已存在',
    'error26010034': '已存在自定义报警类型的名称',
    'error41100001': '插入的日志列表长度为0',
    'error41100002': '插入的日志参数为空值',
    'error41100003': '日志查询传入参数错误',
    'error41100004': '日期格式错误，应为yyyy-MM-dd',
    'error41100005': '事件类型Key已存在',
    'error41100006': '用户名不能为空',
    'error41100007': '用户ID不能为空',
    'error41100008': '操作事件类型不能为空',
    'error41100009': '用户姓名不能超过50字符',
    'error41100010': '模块编码不能超过10字符',
    'error41000011': '操作时间不能为空',
    'error41100012': '插入的日志列表长度为0',
    'error41100013': '事件类型Key不能为空',
    'error41100014': '事件类型Key不能超过64字符',
    'error41100015': '事件类型名称不能超过50字符',
    'error41100016': '上报子系统编码不能为空',
    'error41100017': '开始时间大于结束时间',
    'error41100018': '导出数据量超过10万,请筛选后导出',
    'error41200001': '设备编号不能为空',
    'error41200002': '设备编号不能超过50字符',
    'error41200003': '设备名称不能为空',
    'error41200004': '设备名称不能超过100字符',
    'error41200005': '设备所属组织Code不能超过50字符',
    'error41200006': '设备状态不能为空',
    'error41200007': '状态发生时间不能为空',
    'error41300001': '服务编码不能为空',
    'error41300002': '服务编码不能超过20字符',
    'error41300003': '服务名称不能为空',
    'error41300004': '服务名称不能超过50字符',
    'error41300005': '服务状态不能为空',
    'error41300006': '所属服务器不能超过50字符',
    'error41300007': '服务类型Key不能超过50字符',
    'error41300008': '服务类型Key不能为空',
    'error41300009': '服务类型名称不能超过50字符',
    'error41300010': '服务编码已存在',
    'error41300011': '该服务类型Key不存在',
    'error41300012': '服务类型Key已存在',
    'error41400001': '校时对象名称不能为空',
    'error41400002': '校时对象名称不能超过100字符',
    'error41400003': '校时服务器IP不能超过20字符',
    'error41400004': '校时时间不能为空',
    'error20010001': '搜索返回结果超过范围，请增加搜索字段精确度',
    'error99020030': '未知运行时错误',
    'error28130024': '该主动注册ID已被占用，请重新设置',
    'error40031006': '短信中心号码格式错误',
    'error20010002': '密码不能为空',
    'error20010003': '密码长度超过限制',
    'error20010004': '设备名称不允许为空',
    'error20010005': '设备名称长度超过限制',
    'error20010006': '通道数量超过限制',
    'error20010007': '通道名称不允许为空',
    'error20010008': '通道名称长度超过限制',
    'error20010009': '唯一标识码不允许为空',
    'error20010010': '唯一标识码长度超过限制',
    'error20010011': '唯一标识码错误',
    'error20010012': '授权license，视频通道数量超过license限制数{0}!',
    'error20010013': '未授权license，视频通道数量超过license限制数{0}!',
    'error20010014': '授权license，结构化通道数量超过license限制数{0}!',
    'error20010015': '未授权license，结构化通道数量超过license限制数{0}!',
    'error20010016': '授权license，智能通道数量超过license限制数{0}!',
    'error20010017': '未授权license，智能通道数量超过license限制数{0}!',
    'error20010018': '授权license，AI鱼眼通道数量超过license限制数{0}!',
    'error20010019': '未授权license，AI鱼眼通道数量超过license限制数{0}!',
    'error20010020': '授权license，热成像通道数量超过license限制数{0}!',
    'error20010021': '未授权license，热成像通道数量超过license限制数{0}!',
    'error20010022': '授权license，雷达通道数量超过license限制数{0}!',
    'error20010023': '未授权license，雷达通道数量超过license限制数{0}!',
    'error20010024': '授权license，人脸通道数量超过license限制数{0}!',
    'error20010025': '未授权license，人脸通道数量超过license限制数{0}!',
    'error20010026': '授权license，单兵设备通道数量超过license限制数{0}!',
    'error20010027': '未授权license，单兵设备通道数量超过licens限制数{0}!',
    'error20010028': '授权license，车载设备通道数量超过license限制数{0}!',
    'error20010029': '未授权license，车载设备通道数量超过licens限制数{0}!',
    'error20010030': '授权license，人数统计通道数量超过license限制数{0}!',
    'error20010031': '未授权license，人数统计通道数量超过license限制数{0}!',
    'error28110067': '获取平台加密狗信息失败',
    'error1001': '请求失败，请稍后再试',
    'error6045': '设备IP和端口重复',
    'error6108': '通道数量超过license授权数量',
    'error6164': 'license已过期',
    'error28130034': '设备通道名称格式非法',
    'error49003003': '已存在同名或同编号的设备',
    'error49008002': '不能在非营业组织下面添加营业组织',
    'error29100002': '请先点击通道页签查看信息',
    'error49005002': '已存在名称为:{0}的营业时段规则!',
    'error49003005': '请先至门禁记录查询模块进行断线续传操作',
    'error20010032': '设备输出通道已经绑定到电视墙，通道参数不能更新!',
    'error26010035': '报警类型是否保存非法',
    'error26010036': '报警类型是否保存值非法',
    'error26010037': '报警类型是否保存不能为空',
    'error3101': '录像资源已损坏',
    'error43100014': '报警输入通道路数超限',
    'error43100015': '未找到报警输入通道授权类型',
    'error43100016': '加密狗信息读取失败',
    'error28160052': '人员生物特征索引index不能为空',
    'error28160053': '人员导出数据为空',
    'error29700001': '组织已绑定场区，不允许删除',
    'error28200004': '资源通道不存在',
    'error28160054': '人员已绑定用户',
    'error26030120': '替代预案计划不能为空',
    'error26030121': '预案计划时间段不能为空',
    'error26030122': '预案计划所属星期时间段不能为空',
    'error26030123': '预案计划所属星期开始时间不能为空',
    'error26030124': '预案计划所属星期结束时间不能为空',
    'error28160055': '人员密码校验非法',
    'error28140018': '卡片持有人校验',
    'error28140019': '主卡介质校验',
}